export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_VALIDATE = 'AUTH_VALIDATE';
export const AUTH_REQUEST_BBVA = 'AUTH_REQUEST_BBVA';
export const AUTH_LOGOUT_BBVA = 'AUTH_LOGOUT_BBVA';
export const AUTH_REQUEST_REFRESH_BBVA = 'AUTH_REQUEST_REFRESH_BBVA';
